import { createRouter, createWebHashHistory } from 'vue-router'
import ProjectDetails from '../views/bsns/projectMap/projList/ProjectDetails.vue'
import login from '../views/login.vue'
const routes = [
  {
    path: '/',
    name: '主页',
    component: () => import('../layout'),
    // redirect:'/index',
    redirect: (to) => {
      console.log('进入重定向逻辑');
      // 检查sessionStorage是否可用
      if (typeof sessionStorage === 'undefined') {
        console.error('sessionStorage不可用');
        return '/index';
      }

      const currentLoginType = sessionStorage.getItem('currentLoginType');
      console.log('currentLoginType的值为:', currentLoginType);

      // 其他判断逻辑...
      let redirectPath;
      if (currentLoginType === 'Bank') {
        redirectPath = '/indexBank';
      } else if (currentLoginType === 'PQ') {
        redirectPath = '/indexPQ';
      } else {
        redirectPath = '/index';
      }

      console.log('将要重定向到:', redirectPath);
      return redirectPath;
    },
    children:[
      {
        path: '/index',
        name: '首页',
        component: () => import('../views/index/index.vue')
      },
      {
        path: '/indexPQ',
        name: '企业首页',
        component: () => import('../views/index/indexpq.vue')
      },
      {
        path: '/indexBank',
        name: '银行首页',
        component: () => import('../views/index/indexbank.vue')
      },
      {
        path: 'projectMagm/details/:id',
        name: '项目详情',
        component: ProjectDetails,
        props: true
      },

      {
        path: '/laborManage/laborFileDetail',
        name: '人员详细信息',
        component: () => import('@/views/bsns/laborManage/laborFileDetail.vue'),
      },
      {
        path: '/laborManage/salaryPayDetail',
        name: '专有账户明细',
        component: () => import('@/views/bsns/laborManage/salaryPayDetail.vue'),
      },
      {
        path: '/laborManage/salaryPayDD',
        name: '工资单明细',
        component: () => import('@/views/bsns/laborManage/salaryPayDD.vue'),
      },
      {
        path: '/baseSettings/userManageTab',
        name: '新增用户',
        component: () => import('@/views/bsns/baseSettings/userManageTab.vue'),
      },
    ]
  },
  {
    path: '/loginfirst',
    name: 'loginfirst',
    component: () => import('../views/loginfirst.vue')
  },
  {
    path: '/login/loginNextCz',
    name: 'login',
    component: login,
    props: (route) => ({ loginType: route.query.type }) // 将 type 作为 prop 传递
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})



export default router
